import type { BusinessComponent } from '../types'

/**
 * @param component Business component name assigned to the route
 */
export const getHandle = (component: BusinessComponent) => {
  return { component }
}
